import moment from "moment";
import {useCallback, useEffect, useState} from "react";

export const useViewport = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleWindowResize = () => {
			setWidth(window.innerWidth);
			setHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleWindowResize);
		return () => window.removeEventListener("resize", handleWindowResize);
	}, []);

	const isSMView = width < 576;
	const isMDView = width > 768 && width < 992;
	const isLGView = width > 992 && width < 1200;
	const isXLView = width > 1200 && width < 1400;
	const isXXLView = width > 1400;

	return { width, height, isSMView, isMDView, isLGView, isXLView, isXXLView };
};

export const useHideHeaderOnMobile = (elementId ,width, maxWidth) => {
	let last_scroll_top = 100;
	const showBanner = (order_header) => {
		order_header.classList.remove("scrolled-down");
		order_header.classList.add("scrolled-up");
	};
	const hideBanner = (order_header) => {
		order_header.classList.remove("scrolled-up");
		order_header.classList.add("scrolled-down");
	};
	const handleEventListener = useCallback(() => {
		const order_header = document.getElementById(elementId);
		showBanner(order_header);
		if (order_header) {
			let scroll_top = window.scrollY;
			if (scroll_top < last_scroll_top && scroll_top > order_header.offsetHeight) {
				showBanner(order_header);
			} else if (scroll_top > order_header.offsetHeight) {
				hideBanner(order_header);
			}
			last_scroll_top = scroll_top;
		}
	}, []);

	useEffect(() => {
		window.removeEventListener("scroll", handleEventListener);
		if (width < maxWidth) {
			window.addEventListener("scroll", handleEventListener);
		}
		return () => window.removeEventListener("scroll", handleEventListener);
	}, [width]);
};

export const useDaysCounter = (expirationDatetime) => {
	if (!expirationDatetime)
		return { isPromotionExpired: null, promotionTimeLeft: null };

	const dateTarget = moment(expirationDatetime).utc().format("YYYYMMDD");
	const { isDateInPast, timeLeft } = calculateTimeDifference(dateTarget);
	const [promotionTimeLeft, setPromotionTimeLeft] = useState(timeLeft);
	const [isPromotionExpired, setIsPromotionExpired] = useState(isDateInPast);

	useEffect(() => {
		const id = setInterval(() => {
			const { isDateInPast, timeLeft } = calculateTimeDifference(dateTarget);
			setPromotionTimeLeft(timeLeft);
			setIsPromotionExpired(isDateInPast);
		}, 1000);
		return () => { clearInterval(id); };
	}, []);

	return { isPromotionExpired, promotionTimeLeft };
};

export const useResize = (myRef) => {
	const [width, setWidth] = useState(0);
	const [height, setHeight] = useState(0);
	const [offsetTop, setOffsetTop] = useState(0);

	useEffect(() => {
		if (myRef.current) {
			setWidth(myRef.current.offsetWidth);
			setHeight(myRef.current.offsetHeight);
			setOffsetTop(myRef.current.offsetTop);
		}
	}, [myRef]);

	return { width, height, offsetTop };
};

export const calculateTimeDifference = (dateTarget) => {
	const now = moment();
	const dateTargetTime = moment(dateTarget);
	const difference = dateTargetTime.diff(now);
	const isDateInPast = now.isAfter(dateTargetTime);
	const timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

	if (difference > 0) {
		timeLeft.days = Math.floor(difference / (1000 * 60 * 60 * 24));
		timeLeft.hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
		timeLeft.minutes = Math.floor((difference / 1000 / 60) % 60);
		timeLeft.seconds = Math.floor((difference / 1000) % 60);
	}
	return { isDateInPast, timeLeft };
};
